import { render } from "./WriteFeedbackHere.vue?vue&type=template&id=20661885&ts=true"
import script from "./WriteFeedbackHere.vue?vue&type=script&lang=ts"
export * from "./WriteFeedbackHere.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__